const Share = WXGAME.Share;
let shareData = {
  img_url: '',
  img_width: '108',
  img_height: '108',
  link: stripKeys(location.href),
  title: '来微信游戏领取奖励',
  appid: 'wx62d9035fd4fd2059',
  desc: ''
};
let shareNewData = Object.assign({}, shareData);
export function stripKeys(url = '') {
  url = url.replace(
    /\b(uin|pass_ticket|key|skey|abtest_cookie|wx_header|debug|vconsole)=[^&]+/g,
    '&'
  );
  url = url.replace(/&+/g, '&');
  url = url.replace(/&+$/g, '').replace(/\?&/, '?');
  url = url.replace(/#.*$/g, '') + '#wechat_redirect';
  return url;
}
export function setShareInfo(obj = {}, cbk = false) {
  let timeline = obj.timeline || obj.title || shareNewData.title || '';
  if (obj) {
    if (obj.link) {
      shareData.link = stripKeys(obj.link);
    }
    if (obj.img_url && /^https?:\/\//i.test(obj.img_url)) {
      shareData.img_url = obj.img_url;
    }
    if (obj.title) {
      shareData.title = obj.title;
    }
    if (obj.desc) {
      shareData.desc = obj.desc;
    }
  }
  if (!obj || !obj.link) {
    shareData.link = stripKeys(location.href);
  }
  function shareCbk(ret, type) {
    if (typeof cbk == 'function') {
      cbk(ret, type);
    }
  }
  shareData.timeline = timeline;
  return shareData;
}
export default {
  stripKeys,
  setShareInfo
};
